import { TServerErrorResponse } from "@/types/errors";
import { http } from "../httpHandler";
import { EntityType, PermissionLevel } from "@/types/entity";

export const ENTITY_PERMISSIONS_GET = "entity-permissions-get";
export const GROUP_PERMISSIONS_GET = "group-permissions-get";
export const PERMISSION_CREATE = "permission-create";
export const PERMISSION_DELETE = "permission-delete";

export interface Permission {
  id: string;
  firmId: string;
  userId?: string;
  entityId: string;
  entityType: EntityType;
  groupId?: string;
  level: PermissionLevel;
  createdAt: number;
  updatedAt: number;
}

export interface PermissionCreatePayload {
  firmId: string;
  userId?: string;
  entityId: string;
  entityType: EntityType;
  groupId?: string;
  level: PermissionLevel;
}

export interface GroupPermission {
  id: string;
  firmId: string;
  name: string;
  createdAt: number;
  updatedAt: number;
}

export const getEntityPermissions = async (
  entityType: EntityType,
  entityId: string
): Promise<Permission[]> => {
  try {
    const response = await http.get<Permission[]>(
      `/permission/entity/${entityType}/${entityId}`
    );
    return response.data;
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};

export const getGroups = async (): Promise<GroupPermission[]> => {
  try {
    const response = await http.get<GroupPermission[]>(`/permission/group`);
    return response.data;
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};

export const createPermission = async (
  data: PermissionCreatePayload
): Promise<Permission> => {
  try {
    const response = await http.post<Permission>(`/permission`, data);
    return response.data;
  } catch (error) {
    throw error as TServerErrorResponse;
  }
};

export const deletePermission = async (
  entityType: EntityType,
  permissionId: string
): Promise<void> => {
  try {
    await http.delete(`/permission/${entityType}/${permissionId}`);
  } catch (error) {
    throw error as TServerErrorResponse;
  }
}; 